import React from "react";
import { Table } from "react-bootstrap";
import Pagination from '../../shared/Pagination'
import RowTablePeriodoFacultad from "./RowTablePeriodoFacultad";
import Skeleton from "react-loading-skeleton";

const TablePeriodFaculty = ({
  pagination,
  faculties,
  setFaculty,
  setShowModal,
  getFaculties,
  loading
}) => {

  const handlePage = (page, pageSize) => {
    getFaculties(page, undefined, pageSize)
  }

  return (
    <>
      <div className="fs-3">Periodos</div>
      <Table>
        <thead>
          <tr>
            <th>Gestión</th>
            <th>Facultad</th>
            <th>Periodo</th>
            <th>Fecha Inicio</th>
            <th>Fecha Fin</th>
            <th style={{textAlign: 'center'}} >Estado</th>
            <th style={{textAlign: 'center'}} className="acciones">Acciones</th>
          </tr>
        </thead>
        <tbody>
          {faculties && faculties.length > 0 ? (
            faculties.map((fac) => {
              return (
                <RowTablePeriodoFacultad key={fac.id}
                  faculty={fac}
                  setFaculty={setFaculty}
                  setShowModal={setShowModal}
                />
              );
            })
          ) : (
            <tr style={{textAlign: 'center'}}>
              <td colSpan={7}>
                {loading ? 
                    <Skeleton count={4} height={40} />
                :
                "No existen facultades"
                }
              </td>
          </tr>
          )}
          <tr>
            <td colSpan={7}>
              {
                faculties?.length > 0 && (
                  <Pagination 
                    totalRecords={pagination.totalRecords}
                    rowsPerPage={pagination.pageSize}
                    rowsPerPageOptions={[10, 25, 50]}
                    page={pagination.currentPage}
                    onPage={handlePage}
                    paginationReport={`Mostrando ${pagination.offset+1}-${pagination.offset+faculties.length} de ${pagination.totalRecords} items.`}
                  />
                )
              }
            </td>
          </tr>
   
        </tbody>
      </Table>
    </>
  );
};

export default TablePeriodFaculty;
